import * as React from 'react'
import { getLocationPath } from '../../utils';
import "./../../style/blog-sidebar.module.css"
import "./../../style/common.module.css"
import { Button } from './../elements'
let throttle = require("lodash.throttle");

declare let stAnalytics: any;



//blog_icon_close
const sendAnalyticsOnClick = (eventName: string, href?: string) => {
    stAnalytics.getInstance().sendButtonEvent(eventName);
    if (href) {
        setTimeout(function () {
            window.open(href, "_self");
        }, 100)
    }
}


type Props = {

}

type CurrentBlogInfo = {
    next: string,
    text: string,
    analytics_event_name: string
}

type State = {
    distanceFromTopLeft: number,
    distanceFromBottomLeft: number,
    divStartingPointLeft: number,
    divEndingPointLeft: number,
    distanceFromTopRight: number,
    distanceFromBottomRight: number,
    divStartingPointRight: number,
    divEndingPointRight: number,
    leftPosition: number
    displayLeftNavbar: boolean,
    displayRightNavbar: boolean,
    neverShowRightSidebar: boolean,
    neverShowLeftSidebar: boolean
    currentBlogInfo: CurrentBlogInfo | undefined,
    RightPosition: number,
}

const blogPage: { [key: string]: CurrentBlogInfo } = {
    "/blog/the-best-way-to-securely-manage-user-sessions/": {
        next: "/blog/should-you-use-express-session-for-your-production-app",
        text: "Should you use Express-session for your production app?",
        analytics_event_name: "button_blog_r.h.s_readnext"
    },
    '/blog/should-you-use-express-session-for-your-production-app/': {
        next: '/blog/oauth-2-vs-session-management',
        text: 'OAuth 2.0 vs Session Management',
        analytics_event_name: "button_blog_r.h.s_readnext"
    },
    '/blog/oauth-2-vs-session-management/': {
        next: "/blog/are-you-using-jwts-for-user-sessions-in-the-correct-way",
        text: "Are you using JWTs for user sessions in the correct way?",
        analytics_event_name: "button_blog_r.h.s_readnext"
    },
    "/blog/are-you-using-jwts-for-user-sessions-in-the-correct-way/": {
        next: '/blog/all-you-need-to-know-about-user-session-security',
        text: 'All you need to know about user session security',
        analytics_event_name: "button_blog_r.h.s_readnext"
    },
    "/blog/all-you-need-to-know-about-user-session-security/": {
        next: '/blog/express-session-vs-supertokens-for-handling-user-sessions',
        text: "Express-session vs SuperTokens for handling user sessions",
        analytics_event_name: "button_blog_r.h.s_readnext"
    },
    "/blog/express-session-vs-supertokens-for-handling-user-sessions/": {
        next: '/blog/cookies-vs-localstorage-for-sessions-everything-you-need-to-know',
        text: "Cookies vs Localstorage for sessions – everything you need to know",
        analytics_event_name: "button_blog_r.h.s_readnext"
    },
    "/blog/cookies-vs-localstorage-for-sessions-everything-you-need-to-know/": {
        next: '/blog/the-best-way-to-securely-manage-user-sessions',
        text: "The best way to securely manage user session",
        analytics_event_name: "button_blog_r.h.s_readnext"
    }
}

class BlogSidebars extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props)
        const path = getLocationPath();
        let uniformPath: string = path.length > 1 && path[path.length - 1] === '/' ? '' : path + '/'
        let currentBlogInfo = undefined
        if (blogPage.hasOwnProperty(uniformPath)) {
            currentBlogInfo = blogPage[uniformPath]
        }
        this.state = {
            distanceFromTopLeft: 0,
            distanceFromBottomLeft: 9,
            divStartingPointLeft: 0,
            divEndingPointLeft: 0,
            leftPosition: 0,
            distanceFromTopRight: 0,
            distanceFromBottomRight: 0,
            divStartingPointRight: 0,
            divEndingPointRight: 0,
            RightPosition: 0,
            displayLeftNavbar: false,
            displayRightNavbar: false,
            neverShowRightSidebar: false,
            neverShowLeftSidebar: false,
            currentBlogInfo: currentBlogInfo,
        }
    }

    componentDidMount() {
        this.handleScrollRight()
        this.handleScrollLeft()
        window.addEventListener('scroll', this.throttledLeft);
        window.addEventListener('scroll', this.throttledRight);
    }

    closeRightSidebar() {
        this.setState({ neverShowRightSidebar: true, displayRightNavbar: false })
    }


    handleScrollRight = () => {
        // if div starting and ending point are missing 

        if (this.state.neverShowRightSidebar) {
            window.removeEventListener('scroll', this.throttledRight);
            return;
        }

        try {
            const windowsWidth = window.screen.width
            const centeringElement = 180

            // getting content where we want to add side navbar
            const elementTargetedBoundingClientRight = document.getElementById('supertokens-post-comments')
            // getting main body
            const bodyBoundlingCLient = document.body.getBoundingClientRect()
            // to determine if we can add the element in right, we d0 (screenwidth - position from left + width of the component)
            let divElementMarginRight = elementTargetedBoundingClientRight!.getBoundingClientRect()!.left + elementTargetedBoundingClientRight!.getBoundingClientRect()!.width + 55
            if (typeof divElementMarginRight === 'number' && windowsWidth - divElementMarginRight - 55 < 285) {
                // it might be tablet or mobile 
                // in case of tablet or mobile, we want it to override the div content 
                divElementMarginRight = windowsWidth - 280
            }
            // for some reason the scroll was going above div in case of  mobile and tablet
            let mobileTopMargin = 0
            let bottomzMargin = 40
            if (windowsWidth < 993) {
                mobileTopMargin = 20
                bottomzMargin = 0
            }
            const divStartingPointRight = elementTargetedBoundingClientRight!.getBoundingClientRect()!.top + mobileTopMargin - (bodyBoundlingCLient.top)
            const divEndingPointRight = elementTargetedBoundingClientRight!.getBoundingClientRect()!.bottom - bottomzMargin
            if (!this.state.displayRightNavbar) {
                this.setState({
                    RightPosition: divElementMarginRight,
                    displayRightNavbar: true
                })
            }
            const userHaveScrolled = window.pageYOffset
            if (divStartingPointRight > userHaveScrolled + centeringElement) {
                this.setState({ distanceFromTopRight: divStartingPointRight + 30 })
            } else if (divEndingPointRight - 265 < 0) {
                this.setState({ distanceFromTopRight: this.state.distanceFromTopRight })
            } else {
                this.setState({ distanceFromTopRight: userHaveScrolled + centeringElement })
            }

        } catch (err) {
            this.setState({ neverShowRightSidebar: true, displayRightNavbar: false })
        }
    }

    handleScrollLeft = () => {
        if (this.state.neverShowLeftSidebar) {
            window.removeEventListener('scroll', this.throttledLeft);
            return;
        }

        try {
            // if div starting and ending point are missing 
            const elementTargetedBoundingClienteft = document.getElementById('main')//https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect
            let centeringElement = 250
            if (elementTargetedBoundingClienteft!.getBoundingClientRect()!.left - 300 < 0) {
                window.removeEventListener('scroll', this.throttledLeft);
                throw new Error('Insufficient margin to display left sidebar')
            }

            let divStartingPointLeft = elementTargetedBoundingClienteft!.getBoundingClientRect()!.top + centeringElement
            const divEndingPointLeft = elementTargetedBoundingClienteft!.getBoundingClientRect()!.bottom - centeringElement
            const getWpImageClass = document.getElementsByClassName('wp-block-image')[0]
            if (getWpImageClass) {
                divStartingPointLeft = getWpImageClass!.getBoundingClientRect()!.top
            }
            if (!this.state.displayLeftNavbar) {
                this.setState({
                    // divEndingPointLeft:  elementTargetedBoundingClienteft!.getBoundingClientRect()!.bottom,
                    leftPosition: elementTargetedBoundingClienteft!.getBoundingClientRect()!.left - 300,
                    displayLeftNavbar: true
                })
            }
            const userHaveScrolled = window.pageYOffset
            if (divStartingPointLeft > userHaveScrolled + centeringElement) {
                this.setState({ distanceFromTopLeft: divStartingPointLeft })
            } else if (divEndingPointLeft - 270 < 0) {
                this.setState({ distanceFromTopLeft: this.state.distanceFromTopLeft })
            } else {
                this.setState({ distanceFromTopLeft: userHaveScrolled + centeringElement })
            }
        } catch (err) {
            this.setState({ neverShowLeftSidebar: true, displayLeftNavbar: false })
        }
    }

    throttledLeft = throttle(this.handleScrollLeft);
    throttledRight = throttle(this.handleScrollRight);

    render() {
        // this is going to be rendered only for blog 
        const currentBlogInfo = this.state.currentBlogInfo
        if (currentBlogInfo === undefined) {
            return null;
        }

        return (
            <div>
                <div className="d-none d-lg-block">
                    <div className="blog-left-siderbar-main" style={{
                        position: "absolute",
                        top: this.state.distanceFromTopLeft,
                        display: this.state.displayLeftNavbar ? 'block' : 'none',
                        left: this.state.leftPosition
                    }}>
                        {/* for Desktop */}
                        <div className="d-none d-md-block">
                            <div className="box-container">
                                <h4 className="font-weight-medium">BY SUPERTOKENS  <img src={'/static/assets/logo.png'} /></h4>
                                <h3>A secure solution for managing user sessions</h3>
                                <div className="sidebar-button">
                                    <Button
                                        buttonFlat={true}
                                        text="LEARN MORE"
                                        link="/"
                                        size={6}
                                        color={3}
                                        analyticsEventName="button_blog_l.h.s_learnmore"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="blog-right-sdebar-main" style={{
                    position: "absolute",
                    top: this.state.distanceFromTopRight,
                    display: this.state.displayRightNavbar ? 'block' : 'none',
                    left: this.state.RightPosition
                }}>
                    <div className="row-custom">
                        <div className="close-button" onClick={() => { sendAnalyticsOnClick('button_blog_popup_close'); this.closeRightSidebar() }}><img src="/static/assets/blog_icon_close.png" /></div>
                        <p>Read next: <a onClick={() => sendAnalyticsOnClick(currentBlogInfo.analytics_event_name, currentBlogInfo.next)}>{currentBlogInfo.text}</a> </p>
                    </div>
                </div>
            </div>
        )
    }
}


export const MobileTabletLeftSidebar = () => {
    return (
        <div className="d-mobile-tablet">
            <div className="blog-left-siderbar-main blog-left-top-bottom-margins">
                <div className="box-container">
                    <h4 className="font-weight-medium">BY SUPERTOKENS  <img src={'/static/assets/logo.png'} /></h4>
                    <h3>A secure solution for managing user sessions</h3>
                    <div className="sidebar-button">
                        <Button
                            buttonFlat={true}
                            text="LEARN MORE"
                            link="/"
                            size={6}
                            color={3}
                        />
                    </div>
                </div>
            </div>
        </div>)
}




export default BlogSidebars


